import React, { createContext, useContext, useMemo } from "react";

import { CoordinatorResolver } from "permissions/resolver/coordinators";
import Loader from "components/loader";
import { PermissionService } from "permissions/resolver/permissions";
import { fetchUserPermissions } from "services/src/permission";
import { selectUser } from "store/src/slices/auth-slice";
import { useFetch } from "hooks/src/useFetch";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const PermissionContext = createContext();

export function PermissionProvider({ children }) {
  const user = useSelector(selectUser);

  const params = useParams();

  const coordinatorResolver = useMemo(() => {
    return new CoordinatorResolver();
  }, []);

  const {
    data: permissions,
    isLoading,
    isError,
  } = useFetch({
    queryFn: fetchUserPermissions,
    queryKey: ["PERMISSIONS", user],
    enabled: !!user,
  });

  if (isLoading) {
    return <Loader />;
  }

  const permissionService = new PermissionService(
    user,
    permissions,
    coordinatorResolver
  );

  permissionService.context = {
    projectSlug: params.project_slug,
    jobId: params.jobId,
    billableId: params.billableId,
    milestoneId: params.milestoneId,
    casestudyId: params.casestudyId,
  };

  return (
    <PermissionContext.Provider value={permissionService}>
      {children}
    </PermissionContext.Provider>
  );
}

export function usePermissions() {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error("usePermissions must be used within a PermissionProvider");
  }
  return context;
}
